import {QuizQuestion} from "types/QuizQuestion";
import {dateTime} from "services/date";

/**
 * Transform the given quiz question by deserializing object properties
 *
 * @internal
 * @param question
 */
export default function deserializeQuizQuestion(question: any): QuizQuestion {
    question.created_at = dateTime(question.created_at)
    question.updated_at = dateTime(question.updated_at)

    return question;
}